import React from 'react';
// import logo from './logo.svg';
import 'antd/dist/reset.css';
import './App.css';
import { LoadProvider } from './contexts/LoadContext';
import { AuthProvider } from './contexts/AuthContext';
import Router from './routers/Routes';
import LoadComponent from './components/LoadingComponent/LoadingComponent';
import { DialogAlerProvider } from './contexts/DialogAlertContext';
// import ROUTES, { RenderRoutes } from './routers/routes';
function App() {
  return (
    <React.StrictMode>
      <LoadProvider>
        <DialogAlerProvider>
          <AuthProvider>
            <LoadComponent />
            <Router />
          </AuthProvider>
        </DialogAlerProvider>
      </LoadProvider>
    </React.StrictMode>
  );
}

export default App;
